import { render, staticRenderFns } from "./TabBeneficiaryHistoryBudget.vue?vue&type=template&id=607617a6&"
import script from "./TabBeneficiaryHistoryBudget.vue?vue&type=script&lang=js&"
export * from "./TabBeneficiaryHistoryBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports